const AbiEntrySummaryResponseHistoryApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-status-response-history/get`,
  GET_DETAIL: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-status-response-history/get-detail`,
};

export default AbiEntrySummaryResponseHistoryApiUrls
